var _circle, _path, _path2, _path3, _path4, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg10 = function Svg10(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8,
    fill: "url(#paint0_linear_906_536210)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7742 21H7.59417C5.72945 20.85 2 19.38 2 14.7C2 11.55 5.0625 9.3 7.25 9.3C7.25 7.95 9 3 14.25 3C17.75 3 19.5 5.25 20.5302 6.6C21.4335 6.15 23.875 6.15 25.1875 6.6C26.5 7.05 30 9.3 30 13.8C30 18.3 26.0625 21 22.7742 21Z",
    fill: "url(#paint1_linear_906_536210)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7764 23.1024C9.9708 23.1567 11.2057 26.4614 10.9168 27.5397C10.7751 28.0545 10.4123 28.4863 9.90772 28.7408C9.40309 28.9953 8.79759 29.0518 8.22345 28.8979C7.6493 28.7441 7.15317 28.3924 6.84339 27.9197C6.53361 27.447 6.43536 26.8917 6.5701 26.375C6.85901 25.2967 9.58189 23.0482 9.7764 23.1024Z",
    fill: "#42A0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7764 23.1024C16.9708 23.1567 18.2057 26.4614 17.9168 27.5397C17.7751 28.0545 17.4123 28.4863 16.9077 28.7408C16.4031 28.9953 15.7976 29.0518 15.2234 28.8979C14.6493 28.7441 14.1532 28.3924 13.8434 27.9197C13.5336 27.447 13.4354 26.8917 13.5701 26.375C13.859 25.2967 16.5819 23.0482 16.7764 23.1024Z",
    fill: "#42A0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5983 28.5143C24.3311 28.6708 24.0042 28.6067 23.8681 28.371L23.1122 27.138L22.3112 28.3959C22.1589 28.6216 21.8282 28.6628 21.5725 28.4879C21.3168 28.313 21.233 27.9883 21.3852 27.7626L22.154 26.5554L20.4961 26.5556C20.2243 26.5485 20.0103 26.2928 20.0183 25.9846C20.0262 25.6764 20.2531 25.4323 20.525 25.4395L22.0708 25.4393L21.2463 24.0944C21.1103 23.8588 21.2166 23.5409 21.4838 23.3844C21.7511 23.2279 22.078 23.2921 22.214 23.5277L23.1303 25.0223L24.0825 23.527C24.2348 23.3013 24.5655 23.2601 24.8212 23.435C25.0769 23.6099 25.1607 23.9346 25.0085 24.1604L24.1941 25.4392L25.5399 25.439C25.8118 25.4462 26.0258 25.7018 26.0178 26.01C26.0099 26.3182 25.783 26.5623 25.5111 26.5551L24.0701 26.5553L24.8359 27.8043C24.9719 28.0399 24.8656 28.3578 24.5983 28.5143Z",
    fill: "#42A0F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_906_536210",
    x1: 3,
    y1: 2.5,
    x2: 15.375,
    y2: 14.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAE359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEB41C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_906_536210",
    x1: 6.91448,
    y1: 4.5068,
    x2: 24.7045,
    y2: 21.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDCFE1"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg10, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/10.e90daa14.svg";
export { ForwardRef as ReactComponent };